import './../index.css';
/**
 * Переключает элемент в наборе.
 */
const toggle = (set, item, state) => {
    if (state && !set.has(item)) {
        set.add(item);
        return true;
    }
    else if (!state && set.has(item)) {
        set.delete(item);
        return true;
    }
    return false;
};

export { toggle as default };
//# sourceMappingURL=dummyToggle.js.map
